import * as React from 'react'
import HoverMenu from 'material-ui-popup-state/HoverMenu'
import MenuItem from '@mui/material/MenuItem'
import Divider from '@mui/material/Divider'
import Button from '@mui/material/Button'
import { Link } from 'react-router-dom'
import {
  usePopupState,
  bindHover,
  bindMenu,
} from 'material-ui-popup-state/hooks'

/** Visible hover on dropdown rows (default MUI hover is very subtle on white). */
const dropdownItemSx = {
  py: 1.25,
  borderRadius: 1,
  transition: (theme) =>
    theme.transitions.create(['background-color'], {
      duration: theme.transitions.duration.shortest,
    }),
  '&:hover': {
    backgroundColor: 'var(--accent-bg)',
  },
  '&.Mui-focusVisible': {
    backgroundColor: 'var(--accent-bg)',
  },
  '&:active': {
    backgroundColor: 'var(--accent-bg)',
  },
}

const MenuPopupState = ({ label, items, icon, buttonTo }) => {
  const popupState = usePopupState({
    variant: 'popover',
    popupId: `menu-${label.replace(/\s/g, '')}`,
  })

  const resolvedButtonTo = buttonTo ?? items?.find((i) => i?.to)?.to
  return (
    <>
      <Button
        variant="text"
        {...bindHover(popupState)}
        {...(resolvedButtonTo
          ? {
              component: Link,
              to: resolvedButtonTo,
            }
          : {})}
        sx={{
          textTransform: 'none',
          color: 'var(--text-muted)',
          background: 'transparent',
          padding: 'var(--space-2) var(--space-3)',
          borderRadius: 'var(--radius-md)',
          fontSize: 'var(--text-sm)',
          fontWeight: 450,
          letterSpacing: '0.01em',
          transition: 'color var(--transition), background var(--transition)',
          whiteSpace: 'nowrap',
          '&:hover': {
            color: 'var(--text)',
            backgroundColor: 'var(--accent-bg)',
          },
        }}
      >
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 'var(--space-1)' }}>
          {icon}
          {label}
        </span>

      </Button>
      <HoverMenu
        {...bindMenu(popupState)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        {(items || []).map((item, idx) => {
          if (item?.type === 'divider') {
            return <Divider key={`divider-${idx}`} sx={{ my: 0.25 }} />
          }

          if (item?.type === 'section') {
            return (
              <MenuItem
                key={`section-${item.label}-${idx}`}
                disabled
                sx={{
                  ...dropdownItemSx,
                  cursor: 'default',
                  opacity: 1,
                  fontWeight: 700,
                }}
              >
                {item.label}
              </MenuItem>
            )
          }

          if (item?.to) {
            return (
              <MenuItem
                key={item.to}
                component={Link}
                to={item.to}
                onClick={popupState.close}
                sx={dropdownItemSx}
              >
                {item.label}
              </MenuItem>
            )
          }

          return (
            <MenuItem
              key={`${item?.label ?? 'item'}-${idx}`}
              onClick={() => {
                item.onClick?.()
                popupState.close()
              }}
              sx={dropdownItemSx}
            >
              {item.label}
            </MenuItem>
          )
        })}
      </HoverMenu>
    </>
  )
}

export default MenuPopupState